/**
 * Rewrite inline `[n]` citation markers in the markdown into clickable
 * markdown links `[[n]](url "title")` using the citation → URL map extracted
 * from the Annexure. Skips occurrences that live inside the Annexure itself
 * (so its own numbering entries render unchanged).
 */
export function linkifyCitations(md, annexure) {
    if (!md || !annexure) return md;
    // Detect source-list start (new "6.3 Source list" or legacy "## 15. ANNEXURE").
    const startNew = md.search(/^#{2,5}\s+6\.[2-6]\s+Source\s+list/im);
    const startLegacy = md.search(/^##\s+15\.?\s+ANNEXURE/im);
    let annexStart = -1;
    if (startNew >= 0 && startLegacy >= 0) annexStart = Math.min(startNew, startLegacy);
    else annexStart = Math.max(startNew, startLegacy);
    const body = annexStart >= 0 ? md.slice(0, annexStart) : md;
    const tail = annexStart >= 0 ? md.slice(annexStart) : "";
    const replaced = body.replace(/\[(\d+)\](?!\()/g, (match, n) => {
        const entry = annexure[n];
        if (!entry || !entry.url) return match;
        const safeTitle = String(entry.title || "").replace(/"/g, "'");
        return `[[${n}]](${entry.url} "${safeTitle}")`;
    });
    return replaced + tail;
}
